import { HistoryOrders } from '@/features/profile-page/HistoryOrders/ui/HistoryOrders'
import './ui/HistoryOrders.css'
export default HistoryOrders
